import { useTranslation } from 'react-i18next';
import { KoobButton } from '@koob/ui';
import { Link } from 'react-router-dom';

export default function ToConnectionRequestUpdating() {
  const { t } = useTranslation('toConnectionRequest');

  return (
    <div className="my-16">
      <div className="flex-col space-y-6 text-center">
        <i className="far fa-circle-notch fa-spin text-gray-500 fa-4x" />

        <div>
          <h1 className="text-xl font-medium text-gray-700">
            {t('updating.title')}
          </h1>

          <p className="text-gray-500">{t('updating.description')}</p>

          <div className="mt-6">
            <Link to="/to-connection-request/connections">
              <KoobButton>
                <i className="fas fa-arrow-left mr-2" />
                {t('misc:goBack')}
              </KoobButton>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
